import React, { useEffect, useState } from "react";
import { CheckboxWrapper } from "./styled";
import { Label } from "theme-ui";

const Checkbox = ({ 
  name, 
  label,
  value, 
  checked,
  labelSize,
  labelColor,
  labelWeight,
  width, 
  sublabel,
  onChange,
  $customStyles
}: {
  name?: string;
  label?: string | React.ReactNode;  
  value?: string | number;  
  checked?: boolean;
  className?: string;
  labelSize?: string;
  labelColor?: string;
  width?: string;
  sublabel?:string;
  labelWeight?: string;
  onChange?: (e?: any) => void;
  $customStyles?: any
}) => {
  const [newChecked,setNewChecked] = useState<boolean>(checked || false);

  const setSelectValue = function (e: any){            
    if(typeof onChange === "function"){
      onChange(!newChecked)
    }
  }

  useEffect(() => {
    setNewChecked(checked || false)
  },[checked])

  return (
    <CheckboxWrapper $labelSize={labelSize} width={width} labelColor={labelColor} sx={$customStyles} labelWeight={labelWeight}>
      <input type="checkbox" name={name} value={value ?? 1} checked={newChecked} onChange={setSelectValue} />
      {label && <Label onClick={() => typeof onChange === "function" && onChange(!newChecked)}>{label}{sublabel && <div className="sublabel">{sublabel}</div>}</Label>}
    </CheckboxWrapper>
  );
};
export default Checkbox;
